import React from 'react';
import { useTranslation } from 'react-i18next';

export default function PlaylistCompleted() {
	const { t } = useTranslation();
	return (
		<div className='text-center py-12'>
			<div className='inline-block mb-6'>
				<div className='w-20 h-20 bg-blue-50 rounded-full flex items-center justify-center mb-4 mx-auto border border-blue-100'>
					<svg
						className='w-10 h-10 text-blue-600'
						fill='none'
						stroke='currentColor'
						viewBox='0 0 24 24'
					>
						<path
							strokeLinecap='round'
							strokeLinejoin='round'
							strokeWidth={2}
							d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
						/>
					</svg>
				</div>
			</div>

			<h2 className='text-2xl font-semibold text-gray-800 mb-4'>
				{t('common.allTutorialsCompleted')}
			</h2>

			<p className='text-base text-gray-600 mb-6 max-w-lg mx-auto leading-relaxed'>
				{t('common.courseCongratulations')}
			</p>

			<div className='inline-flex items-center bg-blue-50 border border-blue-200 rounded-md px-6 py-3'>
				<span className='text-blue-700 font-medium text-sm'>
					{t('common.courseCompleted')}
				</span>
				<div className='ml-3 w-2 h-2 bg-blue-500 rounded-full'></div>
			</div>
		</div>
	);
}
